export default "__VITE_ASSET__BLrQXiJ$__"